module.exports = __webpack_public_path__ + "img/training.d8060fcd.png";